/* Vitrine open/close.

   Deliberately CLICK-ONLY. There is no scroll listener, no wheel handler and
   no IntersectionObserver in this file, and none should be added: the whole
   point of this interaction is that opening the jar cannot interfere with the
   page scroll. The reference behaviour it replaces (gruns.co) is scroll-driven
   and hijacks the wheel; this does not.

   State lives as `.is-open` on the vitrine, so every moving part is driven by
   CSS transitions off one class. If this script never loads, the jar simply
   stays shut and the section still renders correctly - the closed state is the
   default in CSS, not something JS has to apply. */
(function () {
  function bind(scope) {
    (scope || document).querySelectorAll('[data-vitrine-toggle]').forEach(function (button) {
      if (button.dataset.vitrineBound) return;
      button.dataset.vitrineBound = '1';

      var vitrine = button.closest('[data-vitrine]');
      if (!vitrine) return;

      button.addEventListener('click', function () {
        var open = vitrine.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        var label = open ? button.dataset.labelClose : button.dataset.labelOpen;
        if (label) {
          button.setAttribute('aria-label', label);
          var text = button.querySelector('[data-vitrine-hint]');
          if (text) text.textContent = label;
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }

  /* Theme editor re-renders a section's DOM wholesale; rebind the new nodes. */
  document.addEventListener('shopify:section:load', function (event) {
    bind(event.target || document);
  });
})();
